<template>
  <div class="content">
    <div class="container-fluid">
      <router-link
        :to="{ path: '/admin/livraison/colisfutur' }"
        class="btn btn-round my-3 border-0"
        style="background-color: #ffab0e; color: #fff"
        type="button"
        uk-toggle="target: #create_commande"
        ><i class="fa fa-plus"></i> Créer une commande future</router-link
      >
      <!-- <autocomplete :search="search" placeholder="Rechercher une commande" aria-label="Choisir une commande" :get-result-value="getResultValue"></autocomplete> -->
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="uk-flex uk-flex-between uk-align-center">
                <h4 class="card-title" style="font-weight: bold">
                  Gestion des colis futurs
                </h4>
                <!-- <form @submit.prevent="validDate" class="ukflex">
                  <div class="ukflex">
                    Choisir une date :
                    <input type="date" v-model="date_created" class="uk-form-width-small">
                  </div>
                  <button class="uk-button uk-label uk-text-right" >Valider</button>
                </form> -->
              </div>
            </template>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="title-tab">#</th>
                  <th scope="col" class="tilte-tab">Noms client</th>
                  <th scope="col" class="tilte-tab">Contact Client</th>
                  <th scope="col" class="tilte-tab">Contact Destinataire</th>
                  <th scope="col" class="tilte-tab">Itineraire</th>
                  <th scope="col" class="tilte-tab">Statut</th>
                  <!-- <th scope="col" class="tilte-tab">Attribué à</th> -->
                  <th scope="col" class="tilte-tab">Valeur colis</th>
                  <th scope="col" class="tilte-tab">Montant</th>
                  <th scope="col" class="tilte-tab">Nature du colis</th>
                  <th scope="col" class="tilte-tab">Date et heure</th>
                  <th scope="col" class="tilte-tab">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(coli, itemObjKey) in Colis"
                  :key="coli.id == 'tyyt'"
                  class="livraison"
                  :class="
                    (coli.statut == 'attente') &
                      (coli.categorie == 'express' || !coli.categorie) ||
                    coli.livreur_id == '3e027c1d-1e14-4097-a263-ce88c1a9915f' ||
                    coli.livreur_id == 'ba30eca4-6a20-4dc3-acc5-fde0735882fb'
                      ? 'uk-text-danger'
                      : (coli.statut == 'attente') &
                        (coli.categorie == 'boutique')
                      ? 'uk-text-primary '
                      : 'uk-text-success'
                  "
                  uk-scrollspy="target: > td; cls:  uk-animation-slide-bottom-small; delay: 150"
                >
                  <td>{{ itemObjKey + 1 }}</td>
                  <td>{{ coli.client_name }}</td>
                  <td>{{ coli.client_phone }}</td>
                  <td>{{ coli.dest_contact }}</td>
                  <td>
                    {{ coli.depart_address }} 
                    <span uk-icon="arrow-right"></span> 
                    {{ coli.dest_address }}</td>
                  <td>
                    <span
                      class="uk-margin-small-right uk-text-center"
                      :uk-icon="
                        coli.statut == 'attente'
                          ? 'icon:warning; ratio: 1.5'
                          : 'icon:check; ratio: 1.5'
                      "
                    ></span>
                  </td>
                  <!-- <td>{{ coli.livreur_name }} F</td> -->
                  <td>{{ coli.valeur }} F</td>
                  <td>{{ coli.montant }} F</td>
                  <td>{{ coli.nature }}</td>
                  <td>
                    {{
                      formatDate(coli.created_at) +
                      " à " +
                      formatHeure(coli.created_at)
                    }}
                  </td>
                  <td>
                    <!-- <button
                      @click="saveColis(coli.id)"
                      class="btn btn-success uk-box-shadow-large mr-2"
                    >
                      <span
                        class=""
                        style="color: #5f5f5f"
                        uk-icon="icon:check; ratio: 1"
                      ></span>
                    </button> -->

                    <router-link
                      :to="{ path: '/editcolisfutur/' + coli.id }"
                      v-bind:tooltip="coli.id"
                      class="btn btn-danger mr-2 uk-box-shadow-large"
                    >
                      <span
                        class=""
                        style="color: green red"
                        uk-icon="icon:pencil; ratio: 1"
                      ></span>
                    </router-link>

                    <button
                      @click="removeColis(coli.id)"
                      class="btn btn-default uk-box-shadow-large"
                    >
                      <span
                        class=""
                        style="color: #5f5f5f"
                        uk-icon="icon:trash; ratio: 1"
                      ></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, dbstore } from "../../main";
import Swal from "sweetalert2";
// import Jwpagination from "jwpagination";

export default {
  name: "Livraisons",
  data() {
    return {
      date_created: "",
      Colis: [],
      count: [],
      livreurName: [],
      livreurs: [],
      Livreur: {},
      access: 0,
      user: {},
      getRole :0,
      role:""
    };
  },

  methods: {
    validDate() {
      let dbRef = db.ref("Colis Requetes")
      dbRef.get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
      })
      .catch((error) => {
        console.log(error);
      });
      db.ref("Colis Requetes")
      .orderByChild("created_at")
      .startAt(this.date_created)
      .once("value")
      .then((dataSnapshot) => {
        dataSnapshot.forEach((childSnapshot) => {
          this.colisDuJour.push(childSnapshot.val())
        });
          this.show = true;
      });
    },
    currentDateTime() {
      const current = new Date();
      const date =
        current.getDate() +
        " - 0" +
        (current.getMonth() + 1) +
        " - " +
        current.getFullYear();
      const dateTime = date;
      return dateTime;
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("fr", options);
    },
    formatHeure(date) {
      const options = { hour: "numeric", minute: "numeric", second: "numeric" };
      return new Date(date).toLocaleString("fr", options);
    },
    searchLivreur(id) {
      db.ref("users")
        .child(id)
        .on("value", (theSnapshot) => {
          const livreurData = theSnapshot.val();
          this.livreurName = livreurData.name;
        });
      return this.livreurName;
    },
    removeColis(key) {
      if (this.access == 5) {
        db.ref("Colis Requetes").child(key).remove();
      }
    },
  },

  created() {
    this.access = this.$store.getters.user.data.role;
      var start = new Date();
      start.setUTCHours(0,0,0,0);
    const dfRef = db.ref("Colis Futur")
      dfRef.on("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          const childDataKey = childSnapshot.key;
          this.Colis = childData;
          itemsArray.push({
            id: childDataKey,
            client_name: childData.client_name,
            client_phone: childData.client_phone,
            colis_type: childData.colis_type,
            depart_address: childData.depart_address,
            dest_address: childData.dest_address,
            dest_contact: childData.dest_contact,
            id_colis: childData.id_colis,
            valeur: childData.valeur,
            montant: childData.montant,
            nature: childData.nature,
            created_at: childData.created_at,
            statut: childData.statut,
            livreur_id: childData.livreur_id,
            payment_method: childData.payment_method,
            categorie: childData.categorie,
          });
        });
        this.Colis = itemsArray.reverse();
      });
  },
};
</script>

<style>
.tilte-tab {
  color: #000000 !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  font-family: "Poppins", sans-serif !important;
}
.livraison {
  font-weight: bold !important;
}
td {
  font-family: "Poppins", sans-serif !important;
  font-size: 0.9em !important;
}
.btn-primary {
  margin-right: 12px;
}
.dateToday {
  padding: 10px;
  border-radius: 20px;
  color: #ffffff !important;
}
.uk-form-width-small {
  background-color: #5dd381 !important;
  color: #ffffff !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  outline: none;
  border-radius: 10px;
  border: none;
}
.uk-label {
  font-size: 0.9em !important;
  font-weight: bold !important;
}
.uk-label:hover {
  background-color: #1f5cdf !important;
}
.uk-label:active {
  background-color: #0c307e !important;
}
</style>

